import API from "./../../utils/GlobalAPI";

export async function getOrderByUserId(id: string) {
  try {
    const res = await API.getMethod(`orders?_where[0][user]=${id}`);
    return res;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function getOrderById(id: string) {
  try {
    const res = await API.getMethod(`orders/${id}`);

    return res;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function countOrdersByUserId(userId: string) {
  try {
    const res = await API.getMethod(
      `orders/count?_where[0][user.id]=${userId}`
    );

    return res;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function postOrder(data: any) {
  try {
    const res = await API.postMethod("orders", data);

    return res;
  } catch (e) {
    console.log(e);
    return null;
  }
}
